export const emptyRenovationListing = {
  categoryGroups: [],
  categories: [],

  title: "",
  brand: "",

  condition: "",

  price: "",
  quantity: "",
  unit: "",

  warranty: false,
warrantyPeriod: "",
warrantyDetails: "",
storeAvailable: false,
productionAvailable: false,
deliveryAvailable: false,
pickupAvailable: false,

storeAddress: "",
productionAddress: "",
  description: "",

  photos: [],

  phone: "",
};
